import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import withStyles from 'isomorphic-style-loader/withStyles';
import CustomModal from '../../../components/Modals/Modal';
import s from './PortraitModeRestrictionModal.scss';

const messages = defineMessages({
  title: {
    id: 'PortraitModeRestrictionModal.title',
    defaultMessage:
      'For optimal experience in quizzes we suggest using device in portrait mode. Turn the device to continue.',
  },
  button: {
    id: 'PortraitModeRestrictionModal.button',
    defaultMessage: 'I understand but want to use landscape mode anyway',
  },
});

const PortraitModeRestrictionModal = ({ isOpen, onClose }) => (
  <CustomModal
    isOpen={isOpen}
    aria-describedby="portrait-mode-restriction-modal"
  >
    <div className={s.modal}>
      <Typography variant="h6">
        <FormattedMessage {...messages.title} />
      </Typography>
      <Button
        data-test-id="YNXyViFEyK3Nm7_SKJgzE"
        color="primary"
        size="medium"
        variant="outlined"
        onClick={onClose}
      >
        <FormattedMessage {...messages.button} />
      </Button>
    </div>
  </CustomModal>
);

PortraitModeRestrictionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default injectIntl(withStyles(s)(PortraitModeRestrictionModal));
